import React, { useState, useCallback } from "react";
import ModalContext from "./ModalContext";

const ModalProvider = ({ children }) => {
	const [render, setRender] = useState(null);
	const [open, setOpen] = useState(false);

	const onClose = useCallback(() => {
		setOpen(false);
	}, []);

	const modal = useCallback((crender) => {
		setRender(() => crender);
		setOpen(true);
	}, []);

	return (
		<React.Fragment>
			<ModalContext.Provider value={modal}>{children}</ModalContext.Provider>
			{render && render({ open, onClose })}
		</React.Fragment>
	);
};

export default ModalProvider;
